import { render, staticRenderFns } from "./ticketstatus.vue?vue&type=template&id=adbac9aa&scoped=true&"
import script from "./ticketstatus.vue?vue&type=script&lang=js&"
export * from "./ticketstatus.vue?vue&type=script&lang=js&"
import style0 from "./ticketstatus.vue?vue&type=style&index=0&id=adbac9aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbac9aa",
  null
  
)

export default component.exports